import Navigation from '../components/sections/Navigation';
import HeroSection from '../components/sections/HeroSection';
import MarqueeSection from '../components/sections/MarqueeSection';
import AboutSection from '../components/sections/AboutSection';
import SolutionsSection from '../components/sections/SolutionsSection';
import ProductsSection from '../components/sections/ProductsSection';
import WhyHireSphereSection from '../components/sections/WhyHireSphereSection';
import ClientsSection from '../components/sections/ClientsSection';
import TeamSection from '../components/sections/TeamSection';
import CareersSection from '../components/sections/CareersSection';
import ContactSection from '../components/sections/ContactSection';
import Footer from '../components/sections/Footer';

export default function HomePage() {
  return (
    <div data-testid="homepage" className="min-h-screen">
      <Navigation />
      <main>
        <HeroSection />
        <MarqueeSection />
        <AboutSection />
        <SolutionsSection />
        <ProductsSection />
        <WhyHireSphereSection />
        <ClientsSection />
        <TeamSection />
        <CareersSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
